import { Directive, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { UsersFilter } from '../../../../core/store/admin/users/users-filter.interface';

@Directive()
export abstract class UserFilterComponent implements OnInit {
  userFilterForm: UntypedFormGroup;

  @Output()
  filterUsers = new EventEmitter<{ value: UsersFilter; valid: boolean }>();
  defaultValues: any;

  constructor(protected formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.userFilterForm = this.formBuilder.group(this.getControlsConfig());
    setTimeout(() => {
      this.defaultValues = this.defaultValues ? this.defaultValues : this.userFilterForm.value;
    }, 300);
  }

  protected getControlsConfig() {
    return {
      lastName: [''],
      firstName: [''],
      email: [''],
      isAssigned: [true],
      isNotAssigned: [true],
      canAccessHomeMarketBonus: [true],
      cannotAccessHomeMarketBonus: [true],
      isActive: [true],
      isNotActive: [true],
      showForeignUsers: [false],
      soldToIds: [[]],
      salesOrganisationIds: [[]],
    };
  }

  resetFilter() {
    this.userFilterForm.setValue(this.defaultValues);
  }
}
